/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive makers count capacity in decimal units (a 1 TB drive is a trillion bytes), but operating systems usually display binary units, so that same drive reads as about 931 GiB. No space is missing — it is just the same number of bytes shown in a different unit.`)
};

const es_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los fabricantes de unidades cuentan la capacidad en unidades decimales (una unidad de 1 TB son un billón de bytes), pero los sistemas operativos generalmente muestran unidades binarias, así que esa misma unidad se lee como aproximadamente 931 GiB. No falta espacio — son solo el mismo número de bytes mostrados en una unidad diferente.`)
};

const de_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufwerkshersteller geben die Kapazität in dezimalen Einheiten an (ein 1-TB-Laufwerk hat eine Billion Byte), aber Betriebssysteme zeigen meist binäre Einheiten an, sodass dasselbe Laufwerk mit etwa 931 GiB angezeigt wird. Es fehlt kein Speicherplatz — es ist einfach dieselbe Anzahl an Byte, nur in einer anderen Einheit dargestellt.`)
};

const nl_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fabrikanten tellen capaciteit in decimale eenheden (een 1 TB-schijf is een miljard bytes), maar besturingssystemen geven meestal binaire eenheden weer, dus dezelfde schijf leest ongeveer 931 GiB. Er ontbreekt geen ruimte — het zijn gewoon hetzelfde aantal bytes weergegeven in een ander eenheid.`)
};

const fr_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les fabricants de lecteurs comptent la capacité en unités décimales (un lecteur de 1 TB correspond à un billion d'octets), mais les systèmes d'exploitation affichent généralement les unités binaires, donc ce même lecteur se lit comme environ 931 GiB. Aucun espace n'est manquant — c'est simplement le même nombre d'octets affichés dans une unité différente.`)
};

const it_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I produttori di unità di archiviazione calcolano la capacità in unità decimali (un'unità di archiviazione da 1 TB è un trilione di B), ma i sistemi operativi di solito visualizzano unità binarie, quindi quella stessa unità di archiviazione si legge come circa 931 GiB. Nessuno spazio mancante — è solo lo stesso numero di B mostrato in un'unità diversa.`)
};

const pt_br2_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os fabricantes de drives contam a capacidade em unidades decimais (um drive de 1 TB é um trilhão de bytes), mas os sistemas operacionais geralmente exibem unidades binárias, então esse mesmo drive lê aproximadamente 931 GiB. Nenhum espaço está faltando — é apenas o mesmo número de bytes mostrado em uma unidade diferente.`)
};

const pt_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os fabricantes de unidades contam a capacidade em unidades decimais (uma unidade de 1 TB é um trilião de bytes), mas os sistemas operativos geralmente exibem unidades binárias, portanto essa mesma unidade lê-se como aproximadamente 931 GiB. Nenhum espaço está faltando — é apenas o mesmo número de bytes mostrado numa unidade diferente.`)
};

const ja_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライブメーカーは容量を10進数ユニット(1 TBドライブは1兆バイト)で数えますが、オペレーティングシステムは通常バイナリユニットを表示するため、同じドライブは約931 GiBとして表示されます。スペースが失われているわけではなく、同じ数のバイトが別のユニットで表示されているだけです。`)
};

const zh_ds_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`硬盘制造商以十进制单位计算容量(标称 1 TB 的硬盘实际为一万亿字节),但操作系统通常以二进制单位显示容量,因此同一块硬盘会显示为约 931 GiB。空间并没有丢失,只是同样数量的字节以不同的单位显示出来而已。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_faq4_a", locale)
	if (locale === "en") return en_ds_faq4_a(inputs)
	if (locale === "es") return es_ds_faq4_a(inputs)
	if (locale === "de") return de_ds_faq4_a(inputs)
	if (locale === "nl") return nl_ds_faq4_a(inputs)
	if (locale === "fr") return fr_ds_faq4_a(inputs)
	if (locale === "it") return it_ds_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_ds_faq4_a(inputs)
	if (locale === "pt") return pt_ds_faq4_a(inputs)
	if (locale === "ja") return ja_ds_faq4_a(inputs)
	return zh_ds_faq4_a(inputs)
};